/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_SubtitleInputs */

const cs_calendar_subtitle = /** @type {(inputs: Calendar_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plánujte prohlídky, hovory a follow-upy. Přetažením přesunete, pravým klikem akce.`)
};

const en_calendar_subtitle = /** @type {(inputs: Calendar_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan viewings, calls and follow-ups. Drag to reschedule, right-click for actions.`)
};

/**
* | output |
* | --- |
* | "Plan viewings, calls and follow-ups. Drag to reschedule, right-click for actions." |
*
* @param {Calendar_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_subtitle = /** @type {((inputs?: Calendar_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_subtitle(inputs)
	return cs_calendar_subtitle(inputs)
});